import { createContext } from "react";

const studyviewerContext = createContext();

export default studyviewerContext;